var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',_vm._b({attrs:{"label":_vm.label},on:{"input":function($event){return _vm.$emit('input', $event)},"click:append":function($event){return _vm.$emit('clickappend')}}},'v-textarea',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }